var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon2, _polygon3, _path20, _path21, _path22, _path23, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 698.81 597.74",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 401.65,
    y1: 531.54,
    x2: 412.84,
    y2: 766.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 343.73,
    y1: -19.89,
    x2: 352.93,
    y2: 557.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 347.72,
    y1: 229.94,
    x2: 317.85,
    y2: 238.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 187.08,
    y1: 72.58,
    x2: 175.47,
    y2: 306.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 254.98,
    y1: 145.35,
    x2: 260.59,
    y2: 145.35,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 211.53,
    y1: 146.59,
    x2: 219.07,
    y2: 146.59,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 215.55,
    y1: 147.29,
    x2: 214.69,
    y2: 151.2,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1035.91,
    y1: 145.99,
    x2: 1035.06,
    y2: 149.9,
    gradientTransform: "matrix(-1, 0, 0, 1, 1292.73, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 344.61,
    y1: 225.29,
    x2: 482.94,
    y2: 225.29,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 410.4,
    y1: 309.41,
    x2: 407.64,
    y2: 637.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 543.37,
    y1: 340.22,
    x2: 513.15,
    y2: 518.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 532.19,
    y1: 250.07,
    x2: 645.19,
    y2: 250.07,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 234,
    y1: 169.8,
    x2: 237.72,
    y2: 186.95,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 225.86,
    y1: 118.14,
    x2: 245.01,
    y2: 153.58,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 485.39,
    y1: 284.89,
    x2: 396.05,
    y2: 582.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 344.74,
    y1: 399.82,
    x2: 343.8,
    y2: 636.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 349.95,
    y1: 295.4,
    x2: 344.36,
    y2: 551.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 348.28,
    y1: 399.83,
    x2: 347.35,
    y2: 636.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 353.65,
    y1: 306.57,
    x2: 348.05,
    y2: 562.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 359.05,
    y1: 455.76,
    x2: 348.79,
    y2: 798.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1368,
    y1: 235.8,
    x2: 1338.13,
    y2: 244.23,
    gradientTransform: "matrix(-1, 0, 0, 1, 1841.96, 0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 394.52,
    y1: 313.84,
    x2: 371.37,
    y2: 464.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 593.46,
    y1: 245.74,
    x2: 660.05,
    y2: 341.21,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "26. Video Call") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.31,474.59S41.4,441.91,55,357.55s147-157.92,199.37-213.09S361-5.55,501.3.25,639.71,100.1,705.52,134.38s3.87,153.4,9.68,181.92S795.28,431,705.88,490.52,107.31,474.59,107.31,474.59Z",
    transform: "translate(-53.17)",
    fill: "#b4002f",
    opacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55,557.91v25s3.18,15.65,32.34,14.79,645.68,0,645.68,0,15.78-2.57,18.93-15.43V557.91Z",
    transform: "translate(-53.17)",
    fill: "#b4002f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55,557.91v25s3.18,15.65,32.34,14.79,645.68,0,645.68,0,15.78-2.57,18.93-15.43V557.91Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M663.37,433.13H134.9c-12.52,0-22.67-10.14-22.67-21.68V88.15c0-13.5,10.15-23.65,22.67-23.65H663.37A22.67,22.67,0,0,1,686,87.17v323.3A22.66,22.66,0,0,1,663.37,433.13Z",
    transform: "translate(-53.17)",
    fill: "#b4002f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.39,
    y: 77.83,
    width: 546.92,
    height: 335.25,
    rx: 21.1,
    fill: "#b4002f"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5,
    y: 77.83,
    width: 546.92,
    height: 335.25,
    rx: 21.1,
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M346.14,221.93s-6.67-8.31-12.11-1.45,2.65,23.14,15.48,23.43S346.14,221.93,346.14,221.93Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-3)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.51,
    y: 104.87,
    width: 150.06,
    height: 118.76,
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5,142.5a4.24,4.24,0,0,1-.09,2.06,8,8,0,0,1-1.59,3.34,4.43,4.43,0,0,1-3.25,1.6.56.56,0,0,1-.47-.17A.59.59,0,0,1,255,149c-.08-1.86-.17-4.68,1-6.24C257.08,141.42,259.86,140.16,260.5,142.5Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213,142.4a3,3,0,0,0-1.47,2.67,4.74,4.74,0,0,0,1,3.09,8.49,8.49,0,0,0,2.14,1.77,6.44,6.44,0,0,0,3.28,1.29,1.08,1.08,0,0,0,.9-.33,1.14,1.14,0,0,0,.19-.7C219.16,147.31,217.68,140.13,213,142.4Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M217.26,147.44a2.06,2.06,0,0,1-2-.85c-.74-1.06-1-2.35-2-1.78s-.35,2.74.5,3.93,3.66,2.09,4.14,1.28S217.26,147.44,217.26,147.44Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.11,146.14a2,2,0,0,0,1.95-.85c.75-1.06,1-2.35,2-1.77s.36,2.73-.5,3.92-3.65,2.1-4.13,1.28S255.11,146.14,255.11,146.14Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.86,413.08h1.82C259.63,415.12,258.86,413.08,258.86,413.08Z",
    transform: "translate(-53.17)",
    fill: "none",
    stroke: "#6c62ff",
    strokeMiterlimit: 10,
    strokeWidth: 0.74
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M437.65,297s-1.93,10,9.77,18.53c-2.84,4.11-10.5,12-23.54,15.63h0a54.36,54.36,0,0,1-17.8,1.78c-10.24-.58-19.26-4.95-26.47-10.1l-1.13-.83a84.14,84.14,0,0,1-15-14.56c8.62-5.46,15.83-12.69,8.26-19.09a.79.79,0,0,0-.15-.12,2.11,2.11,0,0,0-.23-.19l-.14-.12c-28.8-22.27-26.53-99-26.53-99,29.2-111,101.07-60.92,116.57-55s26.56,42.6,19.57,83.22C472.7,264.16,437.65,297,437.65,297Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M565.73,413.08h-305c1-1.9,2.22-7.36,3.32-21.39C268.94,329.1,346.48,316,346.48,316a116.71,116.71,0,0,0,11.29-5.23l11.94,14c3.36,3.93,12.2,6.92,12.2,6.92,45.64,22.28,65.57-4.27,70.65-13.05,17.19,8.88,60.75,22.54,84.7,40.65C563.56,379.14,565.73,413.08,565.73,413.08Z",
    transform: "translate(-53.17)",
    fill: "#b4002f"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "502.59 413.08 513.58 310.88 561.12 310.88 565.62 413.99 502.59 413.08",
    fill: "#b4002f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.6,386.71l-2.83,26.37H260.68c1-1.9,2.22-7.36,3.32-21.39C268.94,329.1,346.48,316,346.48,316a116.71,116.71,0,0,0,11.29-5.23l11.94,14c3.36,3.93,12.2,6.92,12.2,6.92,45.64,22.28,65.57-4.27,70.65-13.05,17.19,8.88,60.75,22.54,84.7,40.65A69.73,69.73,0,0,1,558.6,386.71Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-10)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.62 413.99 502.6 413.08 505.43 386.71 513.58 310.88 561.12 310.88 565.62 413.99",
    fill: "url(#linear-gradient-11)",
    style: {
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M644.73,232.2c-.77,2.15-5.27,9.45-9.35,16.61h0c-3.53,6.21-6.72,12.3-6.86,14.83-.29,5.42-7.48,29.25-15.43,36.51-4.9,4.48-2.66,10.72-2.66,10.72l-10.17.33-31,1s2.52-4.76-1.1-6.69-36-41.38-36-41.38,2.35-11.57,16.28-3.85,16.24,13.93,19.7,13.28,3.77-53.83,3.77-53.83.73-24.31,7.18-28.77,5.31,16.12,5.31,16.12l4.26,27.9s10.45-44.31,13.6-46.31,9.35-.3,7.81,8.23c-.36,2-2.45,24.05-2.45,24.05l-1.72,14.46s16.38-35.51,19.37-36.66,7.71.27,6.28,6.28-8.63,36.89-8.85,37.86c.6-.71,14.64-17.6,18-19.27S646.16,228.2,644.73,232.2Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M453.93,316s-5.54,25.09-34.72,26.6c-45.45,2.36-63.29-34.05-63.29-34.05l5.41-3.89s.73,1.07,2.12,2.8C369,314.37,385,331.75,406.08,333c24.1,1.38,37.38-11.7,41.34-17.42a16,16,0,0,0,.9-1.44Z",
    transform: "translate(-53.17)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.9,223.63s-1.93-31.58,24.44-45,88.69-1.9,85.5,45Z",
    transform: "translate(-53.17)",
    fill: "#b4002f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M224.85,156.46v9.31a8.93,8.93,0,0,1-7.45,8.81l-6.54,1.09s9.42,20.52,29.14,15.09,20.59-10.9,20.59-10.9l-4.69-1.63a10,10,0,0,1-6.71-9.4l-.05-12.37Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-13)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216,136.45s-.67,13.43,7.32,24.34c8.66,11.83,20.66,14,28.68,0,2.32-4,6.6-25.48,4.87-32.91S226.56,99.29,216,136.45Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-14)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M212.22,125.87a6.84,6.84,0,0,0,1.61-1.36,5.12,5.12,0,0,0,.55-2.56c.45-6,5.75-10.59,11.33-12.85,10-4.07,22.41-2.34,30.42,5,2.9,2.64,5.42,6,9.18,7.13a4.64,4.64,0,0,1,2.12.9c1.21,1.18.31,3.28-.95,4.42a2.44,2.44,0,0,0-.72.88c-.37,1,.94,1.84,2,2.18a12.28,12.28,0,0,1-3.54,3.23c.7.07.93,1.08.57,1.68a5,5,0,0,1-1.61,1.33c-1.75,1.24-2.63,3.33-3.75,5.16s-2.88,3.61-5,3.48a20.61,20.61,0,0,0-1.55-14.57c-9.76,2.63-20-.51-29.77-3.18a3,3,0,0,0-2.25,0c-1.25.72-.85,2.59-.28,3.91-1.23,0-1.84,1.49-2.09,2.7a32.73,32.73,0,0,0-.62,5.49c0,1.1.8,4.75.29,5.53-1,1.53-2.46-.9-3.34-2.07C212,138.51,207.37,129.78,212.22,125.87Z",
    transform: "translate(-53.17)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9,433.13,57.34,549.67a13.67,13.67,0,0,0,11.38,21.24H738.29a13.67,13.67,0,0,0,11-21.8l-85.9-116Z",
    transform: "translate(-53.17)",
    fill: "#b4002f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9,433.13,57.34,549.67a13.67,13.67,0,0,0,11.38,21.24H738.29a13.67,13.67,0,0,0,11-21.8l-85.9-116Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-15)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "596.45 454.04 92.6 454.04 97.19 444.86 589.57 444.86 596.45 454.04",
    fill: "url(#linear-gradient-16)",
    style: {
      isolation: "isolate"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "606.51 467.48 85.88 467.48 92.6 454.04 596.45 454.04 606.51 467.48",
    fill: "url(#linear-gradient-17)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "617.14 481.69 78.78 481.69 85.88 467.48 606.51 467.48 617.14 481.69",
    fill: "url(#linear-gradient-18)",
    style: {
      isolation: "isolate"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "626.71 494.47 72.39 494.47 78.78 481.69 617.14 481.69 626.71 494.47",
    fill: "url(#linear-gradient-19)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "258.64 503.34 441.22 503.34 466.95 545.55 245.78 545.55 258.64 503.34",
    fill: "url(#linear-gradient-20)",
    style: {
      isolation: "isolate"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M339.41,121.42c.09,1.78.52,3.59.1,5.33A12.87,12.87,0,0,1,337,131.1c-10.86,14.65-11.38,34.27-11.46,52.5,0,4.6,0,9.29,1.32,13.69,1.31,4.25,3.82,8,6.3,11.7,1.19,1.78,10.85,12.71,13,12.94,2.88.31-5.6-47.86,51.92-52.51,5.75-.47,11.45.25,17.22.44,3.41.11,6.82-.32,10.23-.19,5.75.23,11.29,2.08,16.73,3.91,9.85,3.31,20.33,7.08,26.42,15.49l5.5-3L475,206l.21,4.78,1.23,29,12.64-19.07c7.88-11.89,16.06-26.57,10.26-39.6-2.74-6.14-8.27-10.78-10.62-17.09-3.27-8.79.34-18.63-.7-27.95-2-18.16-21.25-29.89-39.42-31.83-4.05-.43-8.15-.52-12.15-1.27a84.8,84.8,0,0,1-11.64-3.43c-7.83-2.68-16.86-5-24-.82-2.79,1.63-5,4.16-8,5.49-5.18,2.33-11.15.53-16.8-.07C364.88,103,338.62,105.42,339.41,121.42Z",
    transform: "translate(-53.17)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M475.54,227.79s6.67-8.31,12.1-1.45-2.65,23.14-15.47,23.43S475.54,227.79,475.54,227.79Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-21)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M423.88,331.16h0s-19.37,9.91-44.27-8.32l-1.13-.83a95.29,95.29,0,0,1-15-14.56c8.62-5.46,15.83-12.69,8.26-19.09,3.74,3,26.39,20.41,41.5,16.29C429.55,300.21,424,330.55,423.88,331.16Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-22)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M635.38,248.82c-3.53,6.21-6.72,12.3-6.86,14.83-.29,5.42-7.48,29.25-15.43,36.51-4.9,4.48-2.66,10.72-2.66,10.72l-10.17.33-1-.1s3.72-14.89-5.71-21.46S573,275.93,574.41,267.93s8.87-25.72,28-16S635.38,248.82,635.38,248.82Z",
    transform: "translate(-53.17)",
    fill: "url(#linear-gradient-23)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 551.66,
    cy: 117.52,
    r: 9.68,
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.0b9e94873dfb8838b65bd336d91a5719.svg";
export { ForwardRef as ReactComponent };